import axios from "axios";
import moment from "moment/moment";
import { SummaryPageValues } from "../../../pages/SummaryPage";

export const finishFullAppForm = async (
  transactionId: string,
  formData: SummaryPageValues
) => {
  const url = process.env.REACT_APP_FINISH_FULL_APPLICATION_URL;
  const data = {
    transaction: {
      id: transactionId,
    },
    formData: formData,
  };

  return axios.post(url, data);
}

const checkStatus = async (id: string) => {
  const checkFinishStatusUrl = process.env.REACT_APP_CHECK_FINISH_STATUS_URL;
  return axios
    .get(`${checkFinishStatusUrl}/${id}?rand=${moment().unix()}`, {
      headers: {
        "Cache-Control": "no-cache, no-store",
        Pragma: "no-cache",
      },
      validateStatus: (status) => status === 200,
    })
    .then((response) => response.data);
};
export { checkStatus };
